import PropTypes from "prop-types";
import classNames from "classnames";
import { createUseStyles } from "react-jss";
import nativeDateSkin from "../../style/common/input-type/native-date.skin";

const useStyles = createUseStyles(nativeDateSkin);

const SearchInputNativeDateTime = ({
  className,
  onChange,
  onKeyUp,
  placeholder,
  value,
  required,
  skin,
}) => {
  const classes = useStyles();

  const inputClassNames = classNames(className, {
    [classes["dark-color-scheme"]]: skin === "dark",
  });

  return (
    <input
      className={inputClassNames}
      onChange={onChange}
      onKeyUp={onKeyUp}
      placeholder={placeholder}
      type="datetime-local"
      value={value}
      required={required}
    />
  );
};

SearchInputNativeDateTime.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

export default SearchInputNativeDateTime;
